import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../../components/ui/alert-dialog";
import { inputCls } from "./ui";

export default function ConfirmAction({ trigger, title, description, confirmLabel = "Confirmar", onConfirm, withReason, testid, pattern }) {
  const [reason, setReason] = useState("");
  const valid = !withReason || (pattern ? pattern.test(reason.trim()) : reason.trim().length >= 3);
  return (
    <AlertDialog onOpenChange={(o) => !o && setReason("")}>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        {withReason && <input autoFocus value={reason} onChange={(e) => setReason(e.target.value)} placeholder={withReason} inputMode={pattern ? "numeric" : undefined} maxLength={pattern ? 4 : 300} className={inputCls} data-testid={`${testid}-reason-input`} />}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Voltar</AlertDialogCancel>
          <AlertDialogAction disabled={!valid} onClick={() => onConfirm(reason.trim())} className="bg-bo-green hover:bg-bo-deep" data-testid={`${testid}-confirm`}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
